// Late-bound store reference. The configured Redux store is registered
// here after creation in store.redux.js — modules that participate in the
// reducer tree itself (slices, action helpers reached via extraReducers)
// would create a circular import if they pulled `store` directly. Reading
// it via this getter at *call time* sidesteps the cycle, because by the
// time any reducer or thunk actually runs the store has long been wired up.
let _store = null;

export const setStore = (store) => {
  _store = store;
};

export const getStore = () => _store;
